import React from 'react'

import LoadingScreenMobile from './Ingreso/loadingScreen.component';
import CarSliderMobile from './Slider/CarSlider.component';
import CarStudioContainerMobile from './CarStudio/carStudio.component';
import GETWebParams from '../helpers/GETWebParams';
import { getSliderData } from '../helpers/strapi.helper';

declare const window: any;

interface Props {}

interface State {
  openCarSlider: boolean,
  currentCarSelected: string,
  openCarStudio: boolean,
  isTouchScreen: boolean
}

class LoadingMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      openCarSlider: false,
      currentCarSelected: '',
      openCarStudio: false,
      isTouchScreen: false
    }
  }

  handleTouchScreen = () => {
    this.setState({
      isTouchScreen: true
    })
  }

  handleOpenCarSlider = () => {
    //WEB GET PARAMS
    const params = GETWebParams()
    var loadedParam = false
    if(params.model !== undefined) {
      Object.keys(getSliderData()).forEach((car: any, index: number) => {
        if( car.toLowerCase() === params.model.toLowerCase() ){
          this.handleOpenCarStudio(car)
          window.sendDataByUrlParams("MODELO", car, undefined, undefined)
          loadedParam = true
        }
      })
    }
    if(loadedParam === false){
      this.setState({
        openCarSlider: true
      })
    }
  }

  handleOpenCarStudio = (payload: string) => {
    this.setState({
      openCarSlider: false,
      openCarStudio: true,
      currentCarSelected: payload
    }, () => 
    window.dataLayer.push({
      'event': 'hero_banner_click',
      'comp_page': {
      'name_banner': payload.toLowerCase(),
      'link': "https://www.hyundaicolombia.co/interactive-car-studio/"
      }
    }))
  }

  handleCloseCarStudio = () => {
    this.setState({
      openCarSlider: true,
      openCarStudio: false,
      currentCarSelected: ''
    })
  }

  render(): React.ReactNode {
      return(
        <div className='loading-component-mobile'>
          <LoadingScreenMobile
            handleOpenCarSlider = {this.handleOpenCarSlider}
          />
          <CarSliderMobile
            openCarSlider={this.state.openCarSlider}
            handleOpenCarStudio = {this.handleOpenCarStudio}
            handleTouchScreen = {this.handleTouchScreen}
          />
          <CarStudioContainerMobile
            openCarStudio = {this.state.openCarStudio}
            currentCarSelected={this.state.currentCarSelected}
            handleCloseCarStudio = {this.handleCloseCarStudio}
            isTouchScreen = {this.state.isTouchScreen}
          />
        </div>
      )
  }
}

export default LoadingMobile